import React from 'react';
import { formatDate, dashBoardformatDate, getCategories, formatFullDate } from '../../../utils';
import { fetchConfigarationData, kudzuPlusTrueFun, appTheme } from '../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
const appConfigData = await fetchConfigarationData();

const TransactionItem = ({ transactionData,getCBKData, cancelTransaction }) => {
    const { IconUri, Description, TransactionTime, TransactionType, Category, ExternalStatus, Amount, DrCrIndicator, StatusCode, IsCoveredByKudzuTransaction, Status } = transactionData;
  const formattedDate = dashBoardformatDate(TransactionTime);
    const formattedFullDate = formatFullDate(TransactionTime);
  const { t } = useTranslation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);

  const date = formattedDate;

    const fullDate = formattedFullDate;
  // const StatusCode='APP';
  const isPending = StatusCode === 'APP';
  const externalText =  StatusCode === 'APP' ? 'Pending' : '';
  const isCredit = DrCrIndicator === "Cr" ? true : false;
  const textColor = DrCrIndicator === "Cr" ? "text-kudzu-text" : "text-secondary-3";
  const prefix = DrCrIndicator === "Cr" ? "+ " : "- ";
  //{`${isPending ? 'italic text-secondary-3 opacity-50' : 'text-secondary-3'}`}


    const styleAll = `font-[400] my-auto font-hanken-grotesk md:text-[16px] sm:text-[11px] text-[16px]`;
    const styleStatus = `font-[400] my-auto font-hanken-grotesk md:text-[16px] sm:text-[11px] text-[16px]`;
    const styleAmount = `font-[600] my-auto font-hanken-grotesk text-[18px]`;
    //console.log("transaction Data", transactionData)
  return (



      <tr className={`${IsCoveredByKudzuTransaction ? 'cursor-pointer' : 'cursor-pointer'}`}
          onClick={() => {
              cancelTransaction({
                  ...transactionData,
                  transactionType: t('ActivityTab'),
              });
          }}
>
          <td width="60" className='table-td-border-bottom py-5 pr-[.5rem]'>
              <span className="transactionCategoryIcon">  <img src={IconUri} alt={t('transaction_category_icon', { category: Category || t('transaction') })} className='h-[14px]' /> </span>
          </td>

          <td className={`table-td-border-bottom py-5 text-left font-[400] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
       ${IsCoveredByKudzuTransaction ? "text-[#30BC89]" : 'text-[var(--text-clr-transactions)]'}`}>
        {Description}       
      </td>
      <td className={`table-td-border-bottom py-5 text-left font-light text-base leading-none tracking-normal hidden sm:table-cell ${styleAll}
      text-[var(--text-clr-transactions)]`}>{Category}</td>     

      <td className={`table-td-border-bottom py-5 text-left hidden sm:table-cell whitespace-nowrap ${styleStatus} 
      ${isPending ? 'text-[var(--text-clr-transactions)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : 'text-[var(--text-clr-transactions)]'}
      `}>
              {/*{externalText}*/}
              {Status === 'Pending' ? fullDate : externalText}
      </td>

          <td
              className={`table-td-border-bottom sm:table-cell flex justify-end py-5 text-right ${styleAmount} ${isCredit
                      ? 'text-[var(--text-clr-transactions-credit)]'
                      : 'text-[var(--text-clr-transactions)]'
                  }`}

      >
        {prefix}
        {parseInt(Amount)}
        .{(Amount % 1).toFixed(2).slice(2)}
        <p className={`${isPending ? 'text-[var(--text-clr-transactions)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : 'text-[var(--text-clr-transactions)]'}
        italic text-[13px] font-[400] sm:hidden block`}> {externalText}</p>
      </td>

      <td className='table-td-border-bottom py-5 pl-4'>
        <img src={appThemeData.ArrowsIconToSee} alt="View details" className='w-[8px] h-[12px] opacity-60' />
      </td>
    </tr>
  );
};



export default TransactionItem;
